// ช่องสัดส่วนช่องทางการจำหน่าย ของแผนการส่งเสริมการกระจายเมล็ดพันธุ์ข้าว (หน่วย: ตัน)
// เรียงตามคอลัมน์บนจอ และตรงกับคอลัมน์ของตาราง DistributionPlanDetail ฝั่ง API
export const AMOUNT_FIELDS = [
  "Campaign", // โครงการ/ส่วนราชการ
  "AgentDiscount0", // ตัวแทนจำหน่าย ราคาเต็ม
  "AgentDiscount5", // ตัวแทนจำหน่าย ลด 5%
  "AgentDiscount7", // ตัวแทนจำหน่าย ลด 7%
  "AgentDiscount8", // ตัวแทนจำหน่าย ลด 8%
  "OtherDiscount0", // เกษตรกร/กลุ่มเกษตรกร/ร้านค้า ราคาเต็ม
  "OtherDiscount5", // เกษตรกร/กลุ่มเกษตรกร/ร้านค้า ส่วนลด
];

// ค่าในช่องกรอกเป็นข้อความมีคอมมา เช่น "1,500" หรือยังไม่ได้กรอก (null / "") ซึ่งนับเป็น 0
export const toAmount = (value) =>
  Number(String(value ?? "").replaceAll(",", "")) || 0;

export const sumAmounts = (row) =>
  AMOUNT_FIELDS.reduce((sum, field) => sum + toAmount(row?.[field]), 0);

// ค่าทุกช่องแปลงเป็นตัวเลขสำหรับส่งให้ API
export const toAmountPayload = (row) =>
  Object.fromEntries(AMOUNT_FIELDS.map((field) => [field, toAmount(row?.[field])]));

// คั่นทุก 3 หลักจากขวา เช่น "1234567" -> "1,234,567"
// (ไม่ใช้ regex แบบ lookahead ซ้ำที่ backtrack — Sonar S8786)
const groupThousands = (digits) => {
  const groups = [];
  for (let end = digits.length; end > 0; end -= 3) {
    groups.unshift(digits.slice(Math.max(0, end - 3), end));
  }
  return groups.join(",");
};

// ระหว่างพิมพ์: เก็บเฉพาะตัวเลข (กันค่าที่วางมาแบบมีตัวอักษร) แล้วใส่คอมมา เช่น "1500" -> "1,500"
export const formatAmountInput = (text) =>
  groupThousands(text.replaceAll(/\D/g, ""));

// ยอดรวมแสดงทศนิยม 2 ตำแหน่ง เช่น 1500 -> "1,500.00"
export const formatTotal = (total) => {
  const [integer, decimals] = Math.abs(total).toFixed(2).split(".");
  const sign = total < 0 ? "-" : "";
  return `${sign}${groupThousands(integer)}.${decimals}`;
};
